import { HttpClient } from '@shared/adapters/HttpClient';

export interface GenericErrorResponse {
  success: boolean;
  message: string;
}

export class GenericErrorApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async solveGenericError(orderId: number): Promise<GenericErrorResponse> {
    try {
      console.log('🔍 GenericErrorApiAdapter - Solving generic error:', {
        orderId,
      });

      const response = await this.httpClient.put(
        `/orders/${orderId}/solve-error/generic`
      );

      console.log('🔍 GenericErrorApiAdapter - Response:', response);

      return {
        success: true,
        message: response.message || 'Error genérico resuelto correctamente',
      };
    } catch (error: any) {
      console.log('🔍 GenericErrorApiAdapter - Error:', error);
      throw error;
    }
  }
}
